/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import React from 'react';
import StubDescription from 'ud-ui/components/stubs/components/stub-description/stub-description';
import StubLinks from 'ud-ui/components/stubs/components/stub-links/stub-links';
import StubLogo from 'ud-ui/components/stubs/components/stub-logo/stub-logo';
import StubPicture from 'ud-ui/components/stubs/components/stub-picture/stub-picture';
import StubSupportLink from 'ud-ui/components/stubs/components/stub-support-link/stub-support-link';
import StubTitle from 'ud-ui/components/stubs/components/stub-title/stub-title';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: ${({ theme }) => theme.colors.DarkBlue};
  color: ${({ theme }) => theme.colors.SurfaceWhite};

  gap: 20px;
  padding: 20px;
`;

const Card = styled.div`
  max-width: 411px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

const TabletStub: React.FC<{ classNames?: string; isLandscape?: boolean }> = (props) => {
  if (props.isLandscape) {
    return (
      <Container className={props.classNames} style={{ padding: '40px' }}>
        <div className="flex max-w-[902px] gap-[70px]">
          <div className="flex flex-col w-[355px] min-w-[355px] items-center justify-between gap-5 text-left">
            <div className="flex flex-col gap-5">
              <StubLogo />
              <StubTitle />
              <StubDescription />
            </div>
            <div />
            <StubLinks />
            <StubSupportLink />
          </div>
          <StubPicture className="w-full" />
        </div>
      </Container>
    );
  }

  return (
    <Container className={props.classNames}>
      <Card>
        <StubLogo />
        <StubTitle />
        <StubDescription />
        <div />
        <StubLinks />
        <StubSupportLink />
      </Card>
    </Container>
  );
};

export default TabletStub;
